import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


const baseUrl = process.env.REACT_APP_SERVER_URL;

export const statisticsApi = createApi({
    reducerPath: 'Statistics',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({

        createImpressions: builder.mutation({
            query: ({ data, userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude }) => {
                return {
                    url: `/statistics/impressions`,
                    method: 'Post',
                    body: { data, userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude },
                }

            },
        }),
        createClicks: builder.mutation({
            query: ({ userId, countryName, city, postal, id, ip, region, capital, deviceType, latitude, longitude }) => {
                return {
                    url: `/statistics/clicks`,
                    method: 'Post',
                    body: { userId, countryName, city, id, postal, ip, region, capital, deviceType, latitude, longitude }
                }

            },
        }),

        createTrackingClicks: builder.mutation({
            query: ({ userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude }) => {
                return {
                    url: `/tracking/clicks`,
                    method: 'Post',
                    body: { userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude }
                }

            },
        }),

        createLinksImpressions: builder.mutation({
            query: ({ userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude }) => {
                return {
                    url: `/links/impressions`,
                    method: 'Post',
                    body: { userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude },
                }

            },
        }),
        createLinksClicks: builder.mutation({
            query: ({ userId, countryName, city, postal, title, ip, region, capital, deviceType, latitude, longitude }) => {
                return {
                    url: `/links/clicks`,
                    method: 'Post',
                    body: { userId, countryName, city, title, postal, ip, region, capital, deviceType, latitude, longitude }
                }

            },
        }),


    })
});

export const {

    useCreateImpressionsMutation,
    useCreateClicksMutation,

    useCreateTrackingClicksMutation,

    useCreateLinksImpressionsMutation,
    useCreateLinksClicksMutation

} = statisticsApi;

